import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { UiHitOverview } from '../adjust-hit-overview/adjust-hit-overview.component';

@Component({
  selector: 'app-hit-overview-columns',
  templateUrl: './hit-overview-columns.component.html',
  styleUrls: ['./hit-overview-columns.component.scss'],
  standalone: false,
})
export class HitOverviewColumnsComponent {
  @Input() columns: UiHitOverview[] = [];
  @Output() columnChanged = new EventEmitter<UiHitOverview[]>();

  searchText = '';

  get filteredColumns(): UiHitOverview[] {
    if (!this.searchText) {
      return this.columns;
    }
    const query: string = this.searchText.toLowerCase();
    return this.columns.filter((column) =>
      column.fieldLabel.toLowerCase().includes(query),
    );
  }

  onColumnDrop(event: CdkDragDrop<Array<UiHitOverview>>): void {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    this.columns.forEach((column, index) => {
      column.fieldOrder = index + 1;
    });
  }

  toggleColumn(column: UiHitOverview): void {
    column.checked = !column.checked;
  }
}
